import { useMutation, useQueryCache } from "react-query";
import { toast } from "react-toastify";
import { ImpactGroup } from "@ecologi/shared";
import { trpc } from "../../../lib/trpc/client";
import { QUERY_KEYS } from "./queryKeys";

export const useCreateImpactGroup = (): ((
  name: string
) => Promise<ImpactGroup>) => {
  const queryCache = useQueryCache();

  const [mutate] = useMutation<ImpactGroup, Error, { name: string }>(
    (input) => trpc.impactGroups.create.mutate(input),
    {
      onSuccess: (newGroup) => {
        // Update cache with new group - this triggers re-renders in useListImpactGroups
        queryCache.setQueryData<ImpactGroup[]>(
          QUERY_KEYS.impactGroups.list,
          (old = []) =>
            [...old, newGroup].sort((a, b) => a.name.localeCompare(b.name))
        );
      },
      onError: (error) => {
        console.error("Failed to create group:", error);
        toast.error(error.message);
        queryCache.invalidateQueries(QUERY_KEYS.impactGroups.list);
      },
    }
  );

  return async (name: string): Promise<ImpactGroup> => {
    return mutate({ name });
  };
};
